export default __webpack_public_path__ + "static/montserrat-c9d988cae9be266b5ef13253456f4493.woff";